/**
 * ¿La interacción «de afuera» que recibió un diálogo pasó en realidad en OTRA
 * capa que estaba encima?
 *
 * El Dialog de Radix (1.1.17) difiere el «clic afuera» al evento `click`
 * (`deferPointerDownOutside`). Si encima hay una confirmación (`useConfirm`),
 * esa confirmación se cierra en ese mismo `click`: cuando el diálogo de abajo
 * evalúa el clic, ya volvió a ser la capa de arriba y lo toma como un clic
 * afuera. Con un cierre protegido eso reabre la pregunta de cierre, que aparece
 * corrida mientras la otra se está yendo, y el diálogo queda trabado. Lo vio
 * Denis en facturación el 28/09/2026 (en Safari, pero pasa en cualquier motor).
 *
 * Dos señales, cualquiera alcanza:
 *  · el elemento ya no está en el documento: la capa donde se hizo clic se
 *    desmontó en el camino;
 *  · el elemento vive dentro de un `alertdialog`: una confirmación nunca es
 *    «afuera» de lo que confirma.
 */
export function vieneDeOtraCapa(target: EventTarget | null): boolean {
  if (typeof Element === 'undefined' || !(target instanceof Element)) return false;
  if (!target.isConnected) return true;
  return target.closest('[role="alertdialog"]') !== null;
}
